import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'users'; // Adjust the URL based on your actual API's URL

const getUsers = async (accessToken) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        };
        const response = await axios.get(API_BASE_URL, config);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch users:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const getUserRole = async (accessToken) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        };
        const response = await axios.get(`${API_BASE_URL}/role`, config);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch user role:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const getSuppliers = async (accessToken) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        };
        const response = await axios.get(`${API_BASE_URL}/Suppliers`, config);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch users:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

export const UsersDataService = {
    getUsers,
    getSuppliers,
    getUserRole
};
